export const InvoiceParsedField = {
  none: 0,
  facilityId: 1 << 0,
  vendorId: 1 << 1,
  total: 1 << 2,
  vendorInvoiceId: 1 << 3,
  date: 1 << 4,
  dueDate: 1 << 5,
  invoiceId: 1 << 6,
};

export const InvoiceItemParsedField = {
  None: 0,
  Description: 1 << 0,
  Quantity: 1 << 1,
  Price: 1 << 2,
  Total: 1 << 3,
  TaxAmount: 1 << 4,
  VendorItemId: 1 << 5,
  UOMType: 1 << 6,
  Category: 1 << 7,
  Subcategory: 1 << 8,
  ExpectedAmount: 1 << 9,
  ExpectedItemPrice: 1 << 10,
};

export const InvoiceAIExtractionFieldMap = {
  facilityId: ['Facility'],
  facility: ['Facility'],
  vendorId: ['VendorName'],
  vendorAddress: ['VendorAddress'],
  invoiceId: ['AccountPoNumber'],
  vendorInvoiceId: ['InvoiceNumber'],
  date: ['InvoiceDate'],
  dueDate: ['InvoiceDueDate'],
  total: ['InvoiceTotal'],
};

export const InvoiceGLItemParsedField = {
  none: 0,
  category: 1 << 0,
  glCode: 1 << 1,
  amount: 1 << 2,
  memo: 1 << 3,
};

export const InvoiceParseStatus = {
  0: 'Pending',
  1: 'InProgress',
  2: 'Completed',
  3: 'Failed',
  4: 'StoppedByUser',
};

export const InvoiceParseQueueStatus = {
  Enqueued: 0,
  Processing: 1,
  Completed: 2,
  Failed: 3,
  StoppedByUser: 4,
  Pending: 5,
  Unprocessable: 6,
};

export const InvoiceOCRStatus = {
  None: 'None',
  InProgress: 'InProgress',
  Completed: 'Completed',
  Failed: 'Failed',
};

export const InvoiceApprovalStatus = {
  Approved: 0,
  Pending: 1,
  Rejected: 2,
};

export const MarkedAsSentStatus = {
  ManuallyPushedBy: 0,
  UpdateOrdersOnly: 1,
  NoChargeMarkedSent: 2,
};

export const InvoicingPath = {
  0: 'new',
  1: 'pending',
  2: 'pendingFilter',
  3: 'awaitingSubmission',
  4: 'invoicesInQueue',
  5: 'rejectedInvoices',
  6: 'previous',
};

export const BookingFailureType = {
  System: 0,
  BookingVendor: 1,
  Integration: 2,
};

export const InvoiceAttachmentCategories = {
  MainInvoiceFile: 1,
  DataFile: 2,
  SecondaryInvoiceFile: 3,
  CancellationDocument: 4,
  InvoiceReport: 5,
  USFoodsDataFile: 6,
  EDIDataFile: 7,
  cXMLDataFile: 8,
  FlatDataFile: 9,
  JSONDataFile: 10,
  ExcelDataFile: 11,
  IntacctDataFile: 12,
};

export const InvoiceVendorSource = {
  0: 'Unknown',
  1: 'Manual',
  2: 'Intacct Integration',
  3: 'Bulk Upload',
};

export const RelatedInvoiceType = {
  SamePurchaseOrder: 0,
  PotentialDuplicate: 1,
  PotentialSpaceDuplicate: 2,
};

export const BookingTypeSubmitRules = {
  sendThroughIntacct: 1,
  sendFacilityEmail: 2,
  sendThroughNHC: 3,
  sendThroughStellar: 4,
  sendFacilityWeeklyEmail: 5,
  sendThroughPCCAvid: 6,
  sendThroughPCC: 7,
  sendThroughWorkday: 8,
  sendThroughQuickbooks: 19,
  sendThroughReliable: 23
};